// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__30pWF","label":"Category_label__3y6aG","content":"Category_content___bviN","header":"Category_header__38TyI","location":"Category_location__31n4c"};